module.exports = {
    DIPERC: 'DIPERC',
    DRAFT_CONT: 'DRAFT_CONT',
    FIPER: 'FIPER',
    FIPRE: 'FIPRE',
    FEIN: 'FEIN',
    FIAE: 'FIAE',
    MORTGAGE_WRITING_LETTER: 'MINUTA',
    INF_CUOTAS_HIPO: 'INF_CUOTAS_HIPO',
    INF_GASTOS_HIPO: 'INF_GASTOS_HIPO',
    ADVERTENCIA_HIPO: 'ADVERTENCIA_HIPO',
    MANIFESTACION_FIRMADA_HIPO: 'MANIFESTACION_FIRMADA_HIPO',
    NUEVA_LEY_DOC_1: 'NUEVA_LEY_DOC_1',
    NUEVA_LEY_DOC_2: 'NUEVA_LEY_DOC_2',
    IDEP: 'IDEP',
    IJ_NS: 'IJ_NS',
    IRPF100: 'IRPF100',
    IRPF100_CLI: 'IRPF100_CLI',
    IRPF130: 'IRPF130',
    IRPF_DIGITAL_FILE_TYPE: 'IRPF_DIGITAL_FILE',
    IRPF_CSV_TYPE: 'IRPF_CSV',
    NOM: 'NOM',
    NOM_VL: 'NOM_VL',
    NS: 'NS',
    NS_CLI: 'NS_CLI',
    NS_FACT: 'NS_FACT',
    OV: 'OV',
    LOANS_INFORMATION: 'PRE_APROB',
    PRE_APROB: 'PRE_APROB',
    TAS: 'TAS',
    TAS_CLI: 'TAS_CLI',
    TAS_CERT: 'TAS_CERT',
    TAS_CERT_CLI: 'TAS_CERT_CLI',
    TAS_DICT: 'TAS_DICT',
    TAS_FACT: 'TAS_FACT',
    VL: 'VL',
    RECIB_HOGAR: 'RECIB_HOGAR',
    RECIB_HIPO: 'RECIB_HIPO',
    RECIB_PREST: 'RECIB_PREST',
    SIGNED_PRECONTRACTUAL: '177',
    LOAN_WRITING: '107',
    EXPENSES_BILL: '187',
    REGISTERED_NS: '248',
    INSURANCE_POLICY: '397',
    INSURANCE_PRE_POLICY: 'PRE_POLIZA_SEGURO_HOGAR',
    DNI_FRONT: 'DNI_FRONT',
    DNI_BACK: 'DNI_BACK',
    NOM_1: 'NOM_1',
    NOM_2: 'NOM_2',
    NOM_3: 'NOM_3',
    JUST_INGRESO1: 'JUST_INGRESO1',
    JUST_INGRESO2: 'JUST_INGRESO2',
    OTROS: 'OTROS',
    OTROS_DOC_INTERVINIENTE: 'OTROS_DOC_INTERVINIENTE',
    UNKNOWN: 'UNKNOWN',
};
